import { computed, Directive, OnInit, signal } from '@angular/core';
import dayjs from 'dayjs';
import { take } from 'rxjs';
import { V2BasePageController } from './base-page.controller';
import { ContentItemCacheBase } from '../services';
import { Pv2ContentMenuItem } from '../models';

@Directive()
export abstract class RecentsDaysPageController
  extends V2BasePageController
  implements OnInit
{
  protected abstract discoveryService: ContentItemCacheBase;

  protected maxDays: number;
  protected daysList = signal<Pv2ContentMenuItem[]>([]);
  protected currentDay = signal<Pv2ContentMenuItem | undefined>(undefined);
  protected currentDayId = signal('');
  protected availableMixes = signal<Pv2ContentMenuItem[] | undefined>(
    undefined,
  );
  protected now: dayjs.Dayjs;
  protected oldestShow: dayjs.Dayjs;

  constructor(maxDays = 14) {
    super();
    this.maxDays = maxDays;
    this.now = dayjs();
    console.debug('Loading days for ', this.now);
    this.oldestShow = this.now.subtract(this.maxDays, 'days');
  }

  ngOnInit() {
    this.buildDaysList();
  }

  buildDaysList() {
    const daysList: Pv2ContentMenuItem[] = [];
    for (let d = 0; d <= this.maxDays; d++) {
      const day = this.now.subtract(d, 'days');
      const dayS = day.format('YYYY-MM-DD');
      const m: Pv2ContentMenuItem = {
        id: dayS,
        name: day.format('dddd'),
        tagLine: day.format('MMMM D'),
      };
      daysList.push(m);
    }
    this.daysList.set(daysList);
    this.showDay(daysList[0]);
  }

  protected updateDaysList(nowId: string) {
    const currentDays = this.daysList();
    const daysList: Pv2ContentMenuItem[] = [];

    for (const d of currentDays) {
      if (nowId === d.id) {
        const m = { ...d };
        m.assignedClasses = ['active'];
        daysList.push(m);
      } else if (d.assignedClasses && d.assignedClasses.length > 0) {
        const m = { ...d };
        m.assignedClasses = undefined;
        daysList.push(m);
      } else {
        daysList.push(d);
      }
    }
    this.daysList.set(daysList);
  }

  protected showDay = (day: Pv2ContentMenuItem | undefined) => {
    if (day) {
      this.discoveryService
        .getArchiveDayFor(day.id, this.oldestShow)
        .pipe(take(1))
        .subscribe((mixes) => {
          this.availableMixes.set(mixes);
          this.currentDay.set(day);
          this.currentDayId.set(day.id);
          this.updateDaysList(day.id);
        });
    }
  };

  protected currentDayName = computed(() => {
    const s = this.currentDay();
    if (s) {
      return s.name + ', ' + s.tagLine;
    }
    return '';
  });
}
